import { Link, Action, linkFields } from '../../core/Link';
import * as THREE from 'three';
import { forwardRef } from 'react';

// Create a reusable Beat Link component
const BeatLinkComponent = forwardRef<THREE.Object3D, { properties: any; isPreview?: boolean }>((props, ref) => {
  // Beat links don't have a visual representation, so we return null
  return null;
});

// Default action for beat links
const defaultAction: Action = {
  id: crypto.randomUUID(),
  name: 'Property Animation',
  type: 'minmax',
  targetItemId: '',
  targetProperty: '',
  range: {
    min: 0,
    max: 1
  },
  enabled: true,
  easing: 'linear',
  curve: 'linear'
};

export const BeatLinkItem: Link = {
  id: '',
  name: 'Beat Link',
  type: 'link',
  linkType: 'beat',
  icon: 'Music',
  settings: {
    triggerBeats: [1],
    duration: 1  // Default duration of 1 beat
  },
  actions: [defaultAction],
  properties: {
    enabled: true,
    position: { x: 0, y: 0, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 }
  },
  fields: [
    ...linkFields.common,
    ...linkFields.beat
  ],
  render: (properties, isPreview, ref) => {
    return null; // Beat links don't have a visual representation
  }
};